import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

import { customReasonOptionValue } from '@common/entities/dialog/export-dialog.entity';

export function CustomExportReasonValidator(formGroup: UntypedFormGroup): { invalid: true } | null {
    const exportReasonControl: UntypedFormControl | null = formGroup.get('exportReasons') as UntypedFormControl;
    const customReasonControl: UntypedFormControl | null = formGroup.get('customReason') as UntypedFormControl;

    if (!(exportReasonControl instanceof UntypedFormControl) || !(customReasonControl instanceof UntypedFormControl)) {
        return { invalid: true };
    }

    const exportReason: string | undefined = exportReasonControl.value ? exportReasonControl.value[0] : undefined;
    const customReason: string | undefined = customReasonControl.value;

    const hasExportReason = !!exportReason;
    const isCustomExportReason: boolean = hasExportReason && exportReason === customReasonOptionValue;
    const hasCustomReason: boolean = !!customReason && customReason.trim() !== '';

    return isCustomExportReason && !hasCustomReason ? { invalid: true } : null;
}
